// THis is only a mixin so i can create named versions of this
const ComponentRenderMixin = {
    props: ["className", "configRoot"],

    template: `
        <div :class="[className]">
            <component v-for="(component, index) in components" :is="component.componentName" :settings="component.settings"></component>
        </div>
    `,
    
    computed: {
        components () {
           
            const configuration =  config[this.configRoot];
            const components = Array.isArray(configuration) ? configuration : [configuration];

      
            return components.filter(c => {

                if(c.hasOwnProperty("visibleIf") && Array.isArray(c.visibleIf)) {
                    if(c.visibleIf.some(route => app.router.normalizeRoute(route) === app.router.route)) {
                        return true
                    }else {
                        return false
                    }
                }
                if(c.hasOwnProperty("hiddenIf") && Array.isArray(c.hiddenIf)) {
                    
                    if(c.hiddenIf.some(route => app.router.normalizeRoute(route) === app.router.route)) {
                        return false
                    }else {
                        return true
                    }
                }   

                return true;
                    
            })
            
        }
    }
}